import React, { Component } from 'react';
import { Row, Col, Card, CardGroup, Button, Form, Container } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { withApollo } from "react-apollo";
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { components } from 'react-select'
import './_mockAnalysis.scss';
import TotalStudentDataModal from '../quiz_section/quiz_summary/totalStudentDataModal.jsx';
import SingleStudentDataModal from '../quiz_section/quiz_summary/singelStudentDataModal.jsx';
import parse, { domToReact } from 'html-react-parser';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';



const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class MocktestAnalysisSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eexamptypeValue: "",
            OngoingTestNames: [],
            completedTestNames: [],
            examNameValue: "",
            viewType: "ongoing",
            exam_id: 0,
            testTypeErrMsg: "",
            examnameErrMsg: "",
            showSpinner: "hide",
            totalStudentDataShow: false,
            singleStudentDataShow: false,
            getEamcetCrashCourseResults: "",
            attempted_exam: "Started",
            studentResults: [],
            mobile: "",
            slno: ''
        }
    }

    handleSelect(val) {
        this.setState({
            viewType: val,
            getEamcetCrashCourseResults: "",
            examNameValue: "",
            attempted_exam: "Started",
        })
    }

    handleSelect2(val) {
        this.setState({
            attempted_exam: val
        })
    }

    singleStudentResult = (row) => {
        this.setState({
            singleStudentDataShow: true,
            mobile: row
        })
    }

    totalStudentResults = (data) => {
        this.setState({
            attempted_exam: "totalStudentResults",
            totalStudentDataShow: true,
            slno: data
        })
    }

    componentDidMount() {
        let ongoingExamNamesArr = [];
        let completedExamNamesArr = [];
        let currentTime = moment().unix()


        this.props.getRizeeMockTests.map((item) => {

            let examDate = moment.unix(item.start_time).format("MMMM DD YYYY")
            let examDateFormat = moment.unix(item.start_time).format("MM-DD-YYYY")
            let examDateFormatUnix = moment(examDateFormat, 'MM-DD-YYYY').unix();

            if (currentTime >= item.start_time && currentTime <= item.end_time) {
                const newOngoingObj = {
                    value: item.id,
                    label: item.exam_name + ' ( ' + examDate + ' ) ',
                    start_time: item.start_time,
                    examDateFormat: examDateFormat,
                    examDateFormatUnix: examDateFormatUnix,
                    end_time: item.end_time,
                    exam_type: item.exam_type
                }

                ongoingExamNamesArr.push(newOngoingObj)
                this.setState({
                    OngoingTestNames: ongoingExamNamesArr
                })
            } else if (item.end_time < currentTime) {
                const newCompletedObj = {
                    value: item.id,
                    label: item.exam_name + ' ( ' + examDate + ' ) ',
                    start_time: item.start_time,
                    examDateFormat: examDateFormat,
                    examDateFormatUnix: examDateFormatUnix,
                    end_time: item.end_time,
                    exam_type: item.exam_type

                }
                completedExamNamesArr.push(newCompletedObj)
                this.setState({
                    completedTestNames: completedExamNamesArr
                })
            }
        })
    }

    getexamtypes() {
        let newArray = [];
        this.props.globals.exams.map((item) => {
            if (item != undefined) {
                if (item.id != "5") {
                    const newObj = {
                        value: item.id,
                        label: item.exam
                    }
                    newArray.push(newObj);
                }
            }
        })
        return newArray;
    }

    tableData(students) {

        const student_data = Array();
        for (let i = 0; i < students.length; i++) {
            student_data.push({
                student_name: students[i].student_name,
                score: students[i].correct_marks - students[i].negative_marks,
                rank: students[i].rank,
                studentAvg: students[i].studentAvg,
                mobile: students[i].mobile,
                student_type: students[i].student_exam_type,
            });
        }
        return student_data;
    }

    resultData(resultData) {
        const question_data = Array();
        for (let i = 0; i < resultData.length; i++) {
            question_data.push({
                index: i + 1,
                correctCount: resultData[i].correct_count,
                wrongCount: resultData[i].wrong_count,
                unanswered: resultData[i].unanswered_count,
                questionID: resultData[i].question_id,
                slno: <a onClick={() => this.totalStudentResults(resultData[i].slno)} style={{ color: "blue" }}>View</a>,

            });
        }
        return question_data;
    }


    selecthandleInputChange = async (ename, evalue) => {
        const name = ename;
        const value = evalue;

        if (name == "exam_type") {
            let eexamptypeData = this.props.globals.exams.find((a) => a.id == value)
            let etesttype1 = [];
            let etesttypevalue1 = [];
            this.props.globals.testTypes.map((item) => {
                if (item != undefined) {
                    const newObj = {
                        value: item.id,
                        label: item.type,
                    }
                    etesttypevalue1.push(newObj);
                    etesttype1.push(item.id);
                }
            })
            this.setState({
                eexamptypeValue: {
                    value: parseInt(value),
                    label: eexamptypeData.exam
                },
                exam_id: parseInt(value),
                getEamcetCrashCourseResults: "",
                examNameValue:""
            })
        }

        if (name == "examName") {
            let allExamNames = this.props.getRizeeMockTests.find((a) => a.id == value)
            this.setState({
                examNameValue: {
                    value: allExamNames.id,
                    label: allExamNames.exam_name
                },
                getEamcetCrashCourseResults: "",
            })
        }
    }

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "student_type",
            text: "Student Type",
            sort: true,
        },
        {
            dataField: "score",
            text: "Score",
            sort: true,
        },
        {
            dataField: "rank",
            text: "Rank",
            sort: true
        },

    ];
    articleColumnsResults = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "studentAvg",
            text: "Overall Average",
            sort: true

        },
        {
            dataField: "score",
            text: "Score",
            sort: true,
        },
        {
            dataField: "rank",
            text: "Rank",
            sort: true
        },
        {
            dataField: "mobile",
            text: "Result",
            formatter: this.actionFormatterStudentName.bind(this)
        },
    ];


    questionColumns = [
        {
            dataField: "index",
            text: "SLNO",
        },
        {
            dataField: "questionID",
            text: "question",
            formatter: this.actionFormatterQuestionData.bind(this),
        },
        {
            dataField: "correctCount",
            text: "Correct",
            sort: true
        },
        {
            dataField: "wrongCount",
            text: "Wrong",
            sort: true
        },
        {
            dataField: "unanswered",
            text: "Unanswered",
            sort: true,
        },
        {
            dataField: "slno",
            text: "Results",
        },
    ];

    rankDefaultsorted = [
        {
            dataField: "score",
            order: "desc"
        }
    ];

    actionFormatterQuestionData(rowData) {
        let questionData = this.state.studentResults.filter((item) => item.question_id == rowData);
        if (questionData[0].qtype == "9" || questionData[0].qtype == "3") {
            let question1 = questionData[0].question.replace(/src="/g, 'src=\\"');
            let question2 = question1.replace(/" \/>/g, '\\" />');
            let question = [];
            try {
                question = JSON.parse(question2);
            }
            catch (err) {
                console.log("MATRIX ERROR:", err.message);
            }

            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <h6 className='font-weight-bold'>List-I</h6>
                            <ol className="matrixlistoptions font-weight-bold" type={
                                questionData[0].list1type == "alphabets" ? ("A")
                                    : (questionData[0].list1type == "numbers") ? ("1")
                                        : ("roman")}
                            >
                                {question.map((item) => (
                                    <li>{parse(item.qlist1)}</li>
                                ))}
                            </ol>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <h6 className=' font-weight-bold'>List-II</h6>
                            <ol className="matrixlistoptions font-weight-bold" type={
                                questionData[0].list2type == "alphabets" ? ("A")
                                    : (questionData[0].list2type == "numbers") ? ("1")
                                        : ("roman")}>
                                {question.map((item) => (
                                    <li>{parse(item.qlist2)}</li>
                                ))}
                            </ol>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>)
        }
        else if (questionData[0].qtype == "8") {
            return (
                <Card as={Card.Body} className="bg-light my-2 font-weight-bold ">
                    {parse(questionData[0].question)}
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }
        else if (questionData[0].qtype == "5") {
            //console.log("questionsData.questionnn", question);
            return (<Card as={Card.Body} className="bg-light my-2 fon-weight-bold">
                {parse(questionData[0].compquestion)}
                {parse(questionData[0].question)}
                <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center font-weight-light">
                            <span className='f-16'>A.</span>
                            <div className="ml-2">{parse(questionData[0].option1)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center font-weight-light">
                            <span className='f-16'>B.</span>
                            <div className="ml-2">{parse(questionData[0].option2)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center font-weight-light">
                            <span className='f-16'>C.</span>
                            <div className="ml-2">{parse(questionData[0].option3)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center font-weight-light">
                            <span className='f-16'>D.</span>
                            <div className="ml-2">{parse(questionData[0].option4)}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
                        <div className="d-flex align-items-center color_000">
                            <span className="font-weight-bold">Correct Answer:</span>
                            <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                        </div>
                    </Col>
                </Row>

            </Card>)
        }
        else {
            return (
                <Card as={Card.Body} className="bg-light my-2 questionData font-weight-bold">
                    {parse(questionData[0].question)}
                    <Row className="my-3">
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center font-weight-light">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }
    }


    actionFormatterStudentName(row) {
        return (
            <>
                <a onClick={() => this.singleStudentResult(row)}>
                    <p style={{ color: "blue" }}>View Results</p>
                </a>
            </>
        )
    }


    getSummaryDetails = async () => {
        this.setState({
            testTypeErrMsg: "",
            examnameErrMsg: ""
        })

        if (this.state.eexamptypeValue == "") {
            this.setState({ testTypeErrMsg: "Please select Exam Type" })
            return;
        } else if (this.state.examNameValue == "") {
            this.setState({ examnameErrMsg: "Please select Exam" })
            return;
        }


        this.setState({ showSpinner: "show" });

        const result = await this.props.client.query({
            query: gql` 
            query(
                $institution_id:Int!
                $exam_paper_id:Int!,
                $type:String!
            ){
                getEamcetCrashCourseResults(
                    institution_id:$institution_id
                    exam_paper_id:$exam_paper_id,
                    type:$type
                ){
                    id
                    exam_name
                    exam_model_type_id
                    attended_count
                    total_students
                    scheduled_time
                    marks
                    completed_count
                    duration
                    results{
                    student_name
                    correct_marks
                    negative_marks
                    attempted_exam
                    rank
                    studentAvg
                    is_started
                    is_completed
                    mobile
                    student_exam_type
                    }
                }
            }
            `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_paper_id: this.state.examNameValue.value,
                type: "All"
            },
            fetchPolicy: 'network-only'
        })

        const studentResults = await this.props.client.query({
            query: gql` 
                query(
                    $exam_paper_id:Int!,
                    $type:String
                    $institution_id:Int
                    ) {
                      getStudent_correct_wrong_results(
                           exam_paper_id: $exam_paper_id,
                           type:$type,
                           institution_id:$institution_id
                        )
                        {
                            slno
                            question
                            option1
                            option2
                            option3
                            option4
                            answer
                            qtype
                            list1type
                            list2type
                            question_id
                            correct_count
                            wrong_count
                            unanswered_count
                            studentResults {
                              name
                              attempt_answer
                              isCorrect
                              mobile
                            }
                    }
                }
              `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_paper_id: this.state.examNameValue.value,
                type: "All"
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getEamcetCrashCourseResults != undefined) {
            this.setState({
                showSpinner: "hide",
                getEamcetCrashCourseResults: result.data.getEamcetCrashCourseResults,
            })
        }
        if (studentResults.data.getStudent_correct_wrong_results != undefined) {
            this.setState({
                studentResults: studentResults.data.getStudent_correct_wrong_results,
                showSpinner: "hide",
            });
        }
    }

    render() {
        let stateFilterData1 = [];
        let ongoingFilterData1 = [];
        let totalReslutArray = [];
        if (this.state.getEamcetCrashCourseResults != "") {
            let filterData = this.state.getEamcetCrashCourseResults.filter(item2 => item2.id == this.state.examNameValue.value);
            let stateFilterData = [];
            if (filterData.length > 0) {
                stateFilterData = filterData[0].results.map((item) => {
                    if (item != undefined) {
                        return item
                    }
                })
            }

            if (this.state.attempted_exam == "Started") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_started == true)
            } else if (this.state.attempted_exam == "NotStarted") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_started == false)
            } else if (this.state.attempted_exam == "Completed") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_completed == true)
            } else if (this.state.attempted_exam == "totalStudentResults") {
                totalReslutArray = this.state.studentResults
            }


            if (this.state.attempted_exam == "Started") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_started == true)
            } else if (this.state.attempted_exam == "NotStarted") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_started == false)
            } else if (this.state.attempted_exam == "Completed") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_completed == true)
            } else if (this.state.attempted_exam == "totalStudentResults") {
                totalReslutArray = this.state.studentResults
            }
        }

        return (
            <section>
                <Container fluid>
                    <Card className='p-3'>
                        <h4 className='text-primary text-center font-weight-bold'>Mock test Analysis Dashboard</h4>
                        <Row>
                            <Col>
                                <ul className='list-inline question_sel_cls mt-3'>
                                    <li className={this.state.viewType == "ongoing" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("ongoing")}>Ongoing</li>
                                    <li className={this.state.viewType == "completed" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("completed")}>Completed</li>
                                </ul>
                            </Col>
                        </Row>
                        <Form>
                            <Row>
                                <Col sm={3}>
                                    <Form.Label className="text-uppercase font-weight-bold mt-2">Test Type <span className='errorCls'>{this.state.testTypeErrMsg}</span></Form.Label>
                                    <SelectDropDown className="dropdown"
                                        name="exam_type"
                                        placeholderName={'Test Type'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                        options={this.getexamtypes()}
                                        handleChange={this.selecthandleInputChange}
                                        stateData={this.state.eexamptypeValue}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Form.Label className="text-uppercase font-weight-bold mt-2">Test name <span className='errorCls'>{this.state.examnameErrMsg}</span></Form.Label>
                                    <SelectDropDown
                                        name="examName"
                                        placeholderName={'Test Name'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                        options={this.state.viewType == "ongoing" ? (this.state.OngoingTestNames.filter(item => item.exam_type == this.state.exam_id)) : (this.state.completedTestNames.filter(item => item.exam_type == this.state.exam_id))}
                                        handleChange={this.selecthandleInputChange}
                                        stateData={this.state.examNameValue}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label className="text-uppercase font-weight-bold mt-2"><span className='errorCls'>{ }</span></Form.Label>
                                    <Form.Group>
                                        <Button type="button" className="m_button float-right mt-3" onClick={() => this.getSummaryDetails()}>Get Details</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                        {
                            this.state.getEamcetCrashCourseResults == "" ?
                                (
                                    <Row>
                                        <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center mt-5" : "hideSpinnerCls text-center"}>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row>
                                )
                                :
                                ("")
                        }

                        {
                            this.state.getEamcetCrashCourseResults != "" ?
                                (
                                    <>
                                        <h4 className='mt-4 text-center text-capitalize'>Exam Name ( <span className='color_blue'>{this.state.getEamcetCrashCourseResults[0].exam_name}</span> )</h4>
                                        <p className='text-center font-weight-bold font_16'>(  Exam Date : {moment.unix(this.state.getEamcetCrashCourseResults[0].scheduled_time).format("DD-MM-YYYY LT")} )</p>

                                        <Row className='mt-5'>
                                            <Col>
                                                <div>
                                                    <h5>Summary</h5>
                                                    <div className='mainBlockUl mt-2'>
                                                        <ul className='list-inline blocksLi'>
                                                            <li class="br_yellow">
                                                                <div class="row">
                                                                    <div class="col-sm-9">
                                                                        <h6 class="font_16">Duration</h6>
                                                                    </div>
                                                                    <div class="col-sm-3 float-right">
                                                                        <i class="far fa-clock f-24 bg_yellow"></i>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].duration + ' Mins'}</h5>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class=" br_green">
                                                                <div class="row">
                                                                    <div class="col-sm-9">
                                                                        <h6 class="font_16">Started</h6>
                                                                    </div>
                                                                    <div class="col-sm-3 float-right">
                                                                        <i class="far fa-user-check f-24 bg_green left_pos"></i>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].attended_count + "/" + this.state.getEamcetCrashCourseResults[0].total_students}</h5>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class=" br_red">
                                                                <div class="row">
                                                                    <div class="col-sm-9">
                                                                        <h6 class="font_16">Not Started</h6>
                                                                    </div>
                                                                    <div class="col-sm-3 float-right">
                                                                        <i class="far fa-user-times f-24 bg_red left_pos"></i>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].total_students - this.state.getEamcetCrashCourseResults[0].attended_count + '/' + this.state.getEamcetCrashCourseResults[0].total_students}</h5>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class=" br_black">
                                                                <div class="row">
                                                                    <div class="col-sm-9">
                                                                        <h6 class="font_16">Completed</h6>
                                                                    </div>
                                                                    <div class="col-sm-3 float-right">
                                                                        <i class="fas fa-file-alt f-24 bg_blue"></i>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <h5 className='mt-2 text-center'>{this.state.getEamcetCrashCourseResults[0].completed_count}</h5>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class=" br_orange">
                                                                <div class="row">
                                                                    <div class="col-sm-8">
                                                                        <h6 class="font_16">Marks</h6>
                                                                    </div>
                                                                    <div class="col-sm-4 float-right">
                                                                        <i class="far fa-file-alt f-24 bg_orange"></i>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].marks}</h5>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='mt-4'>
                                            {
                                                this.state.viewType == "completed" ?
                                                    (
                                                        <>

                                                            <Col sm={3} className='mt-5'>
                                                                <h5 className='mt-2'>Student Details</h5>
                                                            </Col>
                                                            <Col sm={9} className='mt-5'>
                                                                <ul className='d-flex justify-content-end question_sel_cls'>
                                                                    <li className={this.state.attempted_exam == "Started" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Started")}>Started</li>
                                                                    <li className={this.state.attempted_exam == "Completed" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Completed")}>Completed</li>
                                                                    <li className={this.state.attempted_exam == "totalStudentResults" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("totalStudentResults")}>Result Analysis</li>
                                                                </ul>
                                                            </Col>
                                                        </>
                                                    )
                                                    :
                                                    (
                                                        <>
                                                            <Col sm={3} className='mt-5'>
                                                                <h5 className='mt-2'>Student Details</h5>
                                                            </Col>
                                                            <Col sm={9}>
                                                                <ul className='d-flex justify-content-end question_sel_cls'>
                                                                    <li className={this.state.attempted_exam == "Started" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Started")}>Started</li>
                                                                    <li className={this.state.attempted_exam == "Completed" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Completed")}>Completed</li>
                                                                </ul>
                                                            </Col>
                                                        </>
                                                    )
                                            }
                                        </Row>

                                        <Row>
                                            <Col sm={12} className='table_bottom'>
                                                <CardLessDataTableWithOutSearch
                                                    stateData={this.state}
                                                    parentData={this.state.attempted_exam == "totalStudentResults" ? this.resultData(totalReslutArray) : this.state.viewType == "completed" ? this.tableData(stateFilterData1) : this.tableData(ongoingFilterData1)}
                                                    particlecolumns={this.state.attempted_exam == "totalStudentResults" ? this.questionColumns : this.state.attempted_exam != "Completed" ? this.articlecolumns : this.articleColumnsResults}
                                                    defaultSorted={this.rankDefaultsorted}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )
                                :
                                ("")
                        }
                    </Card>
                </Container>
                <TotalStudentDataModal
                    show={this.state.totalStudentDataShow}
                    onHide={() => this.setState({ totalStudentDataShow: false })}
                    data={this.state}
                />

                <SingleStudentDataModal
                    show={this.state.singleStudentDataShow}
                    onHide={() => this.setState({ singleStudentDataShow: false })}
                    stateData={this.state}
                />
            </section >
        )
    }
}

export default withRouter(withApollo(MocktestAnalysisSection));    